import React from 'react'
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import { appRoutes } from './utils/app_routes';
import { About, Blog, Checkout, Contact, Home, Payment, PrivacyPolicy, Shop, TermsOfService } from './pages';
import Product from './pages/Product';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<MainLayout />} >
          <Route path={appRoutes.home} element={<Home />} />
          <Route path={appRoutes.about} element={<About />} />
          <Route path={appRoutes.blog} element={<Blog />} />
          <Route path={appRoutes.checkout} element={<Checkout />} />
          <Route path={appRoutes.shop} element={<Shop />} />
          <Route path={appRoutes.contact} element={<Contact />} />
          <Route path={appRoutes.payment} element={<Payment />} />
          <Route path={appRoutes['terms-of-service']} element={<TermsOfService />} />
          <Route path={appRoutes['privacy-policy']} element={<PrivacyPolicy />} />
          <Route path={'/:name'} element={<Product />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App